import withTracker from '.././withTracker';
import chargeArrears from '../../containers/subscriber/ChargeArrears';

const subscriberChargeArrears = {
  path: '/charge_arrears/:secretKey',
  component: withTracker(chargeArrears)
};

export default subscriberChargeArrears;
